import { all } from 'redux-saga/effects';
import login from './components/login/login.saga';
import app from './components/app/app.saga';

export default function* rootSaga() {
    yield all([
        login(),
        app(),
    ]);
}



// WEBPACK FOOTER //
// ./src/rootsaga.js